// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"86":"a164c71d","187":"b0ad13aa","453":"c129ef9e","733":"ca6e3866","760":"961af0a0","769":"7ccdae9f","801":"67984f4e","835":"607beebd","887":"1c70e90a","954":"92f4e02e"}[chunkId] + ".chunk.js";
};